import React from 'react';
import classNames from 'classnames';
import * as styles from './header.module.sass';
import { Icon } from '../../atoms/icon';
import { NavigationContainer } from '../../organism/NavigationContainer';
import { IconSize } from '../../atoms/icon/enum/size';
import { SearchForm } from '../../molecules/SearchForm';
import { Swicher } from '../../molecules/LanguageSwitcher';
import { HeaderProps } from './props.types';
import { useTranslation } from '../../../i18n/use-translation';
import { Size } from '../../enums/size';
import { useConfig } from '../../../config/context';
import { SupportLink } from '../../organism/SupportLink';
import { DropdownSubMenu } from '../../organism/DropdownSubMenu';
import { useSelector } from 'react-redux';
import { viewportWidthSelector } from '../../../store/app/selector';
import { getCurrentUserSelector } from '../../../store/auth/selector';

export const Header = (props: HeaderProps) => {
  const { t, locale } = useTranslation();
  const config = useConfig();
  const mobileView = useSelector(viewportWidthSelector);
  const user = useSelector(getCurrentUserSelector);


  return (
    <>
     {mobileView > config.MEDIAQUERY.MOBILE &&  <header className={classNames(styles.top_heading_container)}>
        <div className={classNames(styles.header, styles.header_top)}>
          <NavigationContainer titles={props.topTitles} size={Size.EXTRA_SMALL} />
          {mobileView > config.MEDIAQUERY.LAPTOP && (
            <>
              <a className={styles.header_mobile_number} href={`tel: ${config.PHONES.SUPPORT}`}>
                {config.PHONES.SUPPORT}
              </a>
              <SupportLink className={styles.support_nav} />
            </>
          )}
          <Swicher />
        </div>
      </header>}
      <header className={classNames(styles.header, !user ? styles.header_bottom : styles.header_bottomlogged)}>
        <div className={styles.left_header_main}>
          <a href={`/${locale}`}>
            <img src="/public-assets/img/logo/mobile.png" alt="" />
          </a>
          <NavigationContainer titles={props.titles} size={Size.SMALL} desktop_display />
        </div>
        {mobileView > config.MEDIAQUERY.MOBILE && <SearchForm placeholder={t(props.placeholder)} />}
        <DropdownSubMenu />
        {mobileView < config.MEDIAQUERY.LAPTOP && (
          <Icon
            className={'icon-burger'}
            icon={styles.burger_menu}
            size={IconSize.BIGGER}
            onClick={props.showModalHandler}
          />
        )}
      </header>
    </>
  );
};
